import React from 'react';
import { PlayIcon } from 'lucide-react';
interface MediaPlaceholderProps {
  /** Names the exact screenshot that belongs in this slot. */
  label: string;
}
export function MediaPlaceholder({
  label
}: MediaPlaceholderProps) {
  return <div role="img" aria-label={`Media placeholder: ${label} — coming soon`} className="group/media relative flex aspect-video w-full flex-col items-center justify-center gap-3.5 overflow-hidden rounded-xl border border-dashed border-white/20 bg-black/40 px-5 text-center" data-id="element-50" data-mp="18ii9s6d0rf75">
      <span className="pointer-events-none absolute inset-0 bg-[radial-gradient(60%_70%_at_50%_45%,rgba(16,185,129,0.12),transparent_70%)]" data-id="element-51" data-mp="ksxnpelkk1tn" />
      <span className="relative flex h-14 w-14 items-center justify-center rounded-full border border-[#10b981]/40 bg-[#10b981]/10 text-[#10b981] transition-transform duration-200 group-hover/media:scale-105" data-id="element-52" data-mp="uqli23f9j7ba">
        <PlayIcon className="h-5 w-5 translate-x-[1px] fill-[#10b981]" aria-hidden="true" data-id="element-53" data-mp="2658woy2vxxy2" />
      </span>
      <span className="relative font-mono text-[12.5px] font-semibold tracking-tight text-white sm:text-sm" data-id="element-54" data-mp="i98vvn5kmuw1">
        {label}
      </span>
      <span className="relative font-mono text-[10px] uppercase tracking-[0.22em] text-white/50" data-id="element-55" data-mp="da5ovx616elf">
        Screenshot — coming soon
      </span>
    </div>;
}